/**
 * Loading shimmer skeleton for panel loading states.
 */
import { FC } from 'react'

export const PanelSkeleton: FC<{ lines?: number; className?: string }> = ({ lines = 3, className = '' }) => (
  <div className={`space-y-2 animate-pulse ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <div
        key={i}
        className="h-3 bg-muted rounded"
        style={{ width: `${60 + Math.random() * 40}%` }}
      />
    ))}
  </div>
)
